import { render, staticRenderFns } from "./AsidePrefooter.vue?vue&type=template&id=2548988a&"
import script from "./AsidePrefooter.vue?vue&type=script&lang=js&"
export * from "./AsidePrefooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AsidePrefooter.vue"
export default component.exports